var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "support",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    height: 268,
    viewBox: "0 0 290 268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 290,
    height: 268,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2465",
    "data-name": "Group 2465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2445",
    "data-name": "Group 2445",
    transform: "translate(173.832 48.248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 82.657,
    height: 4.263,
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 8.949)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 17.898)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 26.847)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 35.796)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 44.745)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 53.695)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 62.644)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 71.593)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 80.542)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 90.184)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 99.826)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 82.657,
    height: 4.263,
    transform: "translate(0 109.468)",
    fill: "#e27254"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M259.8,270.612c-2.119-19.011-12.752-26.88-52.461-26.88S157,251.6,154.876,270.612s-1.449,58.078-1.449,58.078H261.248S261.918,289.623,259.8,270.612Z",
    transform: "translate(-64.453 -112.896)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 61.991,
    height: 74.985,
    transform: "translate(47.385 45.149)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 35.726,
    height: 43.215,
    transform: "translate(115.56 46.987)",
    fill: "#e27254"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2446",
    "data-name": "Group 2446",
    transform: "translate(214.999 180.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M404.61,339.354H377.653L370.92,371.2h26.957Z",
    transform: "translate(-370.92 -337.785)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M382.537,339.354h26.957l6.734,31.842H389.27Z",
    transform: "translate(-375.803 -337.785)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M424.333,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-392.661 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M417.839,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-389.931 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M411.345,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-387.201 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M404.851,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-384.471 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M398.356,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-381.741 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M391.862,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-379.011 -336.432)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M385.368,338.916a.919.919,0,1,0-.989-.916h-.7a1.7,1.7,0,1,1,1.694,1.569v-.653Z",
    transform: "translate(-376.281 -336.432)",
    fill: "#f97e53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2455",
    "data-name": "Group 2455",
    transform: "translate(83.81 61.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M320.834,282.542c-.444,14.457-1.393,45.164-1.53,47.8a60.392,60.392,0,0,0,10.094-2.361c-2.251-10.753-6.029-21.192-7.208-32.111C321.423,291.244,321.4,286.852,320.834,282.542Z",
    transform: "translate(-218.034 -192.166)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M322.171,268.68s-.089,2.931-.227,7.441c.562,4.311.588,8.7,1.356,13.323,1.179,10.92,4.957,21.358,7.208,32.111a84.906,84.906,0,0,0,10.833-4.735C334.7,295.18,331.471,280.318,322.171,268.68Z",
    transform: "translate(-219.144 -185.745)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M165.6,322.257c-.2-.032-.406-.07-.6-.1l-.209-.038-1.31-.242a54.392,54.392,0,0,1-16.091-5.679c-.864-.44-1.762-.9-2.718-1.4,6.625-22.717,9.842-38.311,19.134-50.524C163.8,264.272,165.419,318.628,165.6,322.257Z",
    transform: "translate(-144.623 -183.703)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M224.792,218.751c5.262-2.639,25.18-4.1,27.028,0s.012,9.327-1.818,10.565-11.7,6.837-11.7,6.837-11.29-3.124-12.667-7.8S223.5,220.427,224.792,218.751Z",
    transform: "translate(-178.025 -161.434)",
    fill: "#2d253f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2447",
    "data-name": "Group 2447",
    transform: "translate(13.205 44.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M261.116,335.654a3.361,3.361,0,0,1-.992,1.2,31.729,31.729,0,0,1-9.921,5.81c-11.067,4.181-24.843,3.878-36.587,4.417a99.278,99.278,0,0,1-20.411-1.056,84.2,84.2,0,0,1-24.017-7.586,3.68,3.68,0,0,1-1.717-2.4,5.318,5.318,0,0,1,.647-3.389c5.365-12.906,4.7-27.491,3.962-42.168q-.579-11.462-1.188-23.332c-.231-4.533-1.021-12.235,1.129-16.6,1.6-3.263,14.061-13.17,24.665-17.1a31.765,31.765,0,0,1,10.348-2.272c2.531-.22,5.025-.341,7.437-.346.665-.006,1.348.016,2.032.06.838.05,1.681.132,2.536.242,1.324.165,2.655.413,4,.7a60.853,60.853,0,0,1,8.542,2.624c12.475,4.781,23.744,13.038,25.61,16.68a13.589,13.589,0,0,1,.463,4.115c.154,4.787-.107,13.126-.565,23.057-.321,6.794-.754,14.331-1.206,21.934A84.8,84.8,0,0,0,260.9,333.8,2.661,2.661,0,0,1,261.116,335.654Z",
    transform: "translate(-167.373 -212.809)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M216.5,230.9l-2.893,8.456s-19.016,16.224-20.738,26.506c-1.348,8.054-.22,58.646.333,80.172a84.2,84.2,0,0,1-24.017-7.586,3.68,3.68,0,0,1-1.717-2.4,5.318,5.318,0,0,1,.647-3.389c5.365-12.906,4.7-27.491,3.962-42.168q-.579-11.462-1.188-23.332c-.231-4.533-1.021-12.235,1.129-16.6,1.6-3.263,14.061-13.17,24.665-17.1a31.765,31.765,0,0,1,10.348-2.272c2.531-.22,5.025-.341,7.437-.346C215.137,230.829,215.82,230.851,216.5,230.9Z",
    transform: "translate(-167.373 -212.809)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M251.728,216.912a48.811,48.811,0,0,1-12.778,10.469,51.847,51.847,0,0,1-13.289-11.146c.4-.11.79-.209,1.177-.3l-.268-18.381,23.839-.3.238,16.009.048,3.339C251.039,216.7,251.384,216.8,251.728,216.912Z",
    transform: "translate(-191.875 -197.255)",
    fill: "#fbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M250.57,208.073l-.161-10.818-23.839.3.268,18.381q-.58.132-1.177.3a57.189,57.189,0,0,0,7.306,7.077C238.986,218.352,244.192,212.485,250.57,208.073Z",
    transform: "translate(-191.875 -197.255)",
    fill: "#e2a0b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451",
    transform: "translate(35.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2448",
    "data-name": "Group 2448",
    transform: "translate(0 31.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M210.6,173.733c-4.741-.13-5.552,3.692-5.087,5.792s3.344,6.478,6.771,3.827C212.586,174.522,210.6,173.733,210.6,173.733Z",
    transform: "translate(-205.397 -173.23)",
    fill: "#e2a0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M280.6,172.811c4.736-.249,5.658,3.551,5.256,5.662s-3.153,6.559-6.657,4C278.633,173.649,280.6,172.811,280.6,172.811Z",
    transform: "translate(-236.377 -172.799)",
    fill: "#fbc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M253.614,153.819c.006,12.917-6.527,25.357-19.948,25.522a18.875,18.875,0,0,1-4.736-.512c-10.318-2.4-15.658-13.213-15.959-24.5-.275-10.531,1.967-18.274,8.951-21.943a24.1,24.1,0,0,1,11.014-2.369C248.711,129.814,253.608,141.545,253.614,153.819Z",
    transform: "translate(-208.572 -121.514)",
    fill: "#fbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M252.168,140.465c-.145,1.806-.719,4.158-.92,6.32a10.182,10.182,0,0,0,.094,3.143l-2.661-9.455s-2.527-1.187-3.076-2.861c-1.141-3.4-1.8-5.31-1.83-5.307-8.164,4.425-26.5.738-26.5.738s-.642,3.885-1.158,5.784a4.94,4.94,0,0,1-3.169,3.1l-1.91,8.505s-3.23-14.8-3.2-20.069c.016-2.05.781-3.945,3.125-4.571a.142.142,0,0,1-.031-.046c-.993-1.683.569-3.709,2.186-4.927,5.995-4.529,13.972-6.26,21.711-6.589a17.868,17.868,0,0,1,7.6.907c2.35.984,4.306,3.13,4.219,5.512a6.379,6.379,0,0,1,5.676,4.26C254.022,129.375,252.534,135.781,252.168,140.465Z",
    transform: "translate(-206.424 -114.182)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2449",
    "data-name": "Group 2449",
    transform: "translate(14.777 35.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M233.65,182.7a1.482,1.482,0,0,1-1.316,1.692,1.667,1.667,0,0,1-1.441-1.727,1.482,1.482,0,0,1,1.316-1.693A1.668,1.668,0,0,1,233.65,182.7Z",
    transform: "translate(-230.891 -180.977)",
    fill: "#29283f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450",
    transform: "translate(30.853 35.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M261.36,182.207a1.526,1.526,0,0,1-1.591,1.476,1.62,1.62,0,0,1-1.125-1.918,1.527,1.527,0,0,1,1.591-1.476A1.62,1.62,0,0,1,261.36,182.207Z",
    transform: "translate(-258.624 -180.275)",
    fill: "#29283f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M226.162,170.154a9.381,9.381,0,0,1,5.537-1.65c1.45.12.463-1-.57-1.011a7.636,7.636,0,0,0-4.939,1.713c-.286.238-.567.627-.347.919a.209.209,0,0,0,.128.087A.293.293,0,0,0,226.162,170.154Z",
    transform: "translate(-213.959 -138.875)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M262.071,168.328a9.53,9.53,0,0,0-5.771-.673c-1.4.366-.653-.9.358-1.091a7.787,7.787,0,0,1,5.2.838c.328.185.683.519.525.843a.2.2,0,0,1-.108.107A.3.3,0,0,1,262.071,168.328Z",
    transform: "translate(-226.471 -138.384)",
    fill: "#29283f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M247.341,192.849a3.325,3.325,0,0,0,2.479-.82c.565-.78-.12-2.386-.346-3.186a38.97,38.97,0,0,0-1.27-3.755,1.957,1.957,0,0,0-.37-.659.79.79,0,0,0-.719-.249,1,1,0,0,0-.543.434,6.256,6.256,0,0,0-.641,2.875q-.23,1.754-.4,3.513C245.417,192.166,246.06,192.814,247.341,192.849Z",
    transform: "translate(-187.017 -146.597)",
    fill: "#e2a0b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2452",
    "data-name": "Group 2452",
    transform: "translate(44.072 57.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M235.627,233.184l-4.8,11.025s-9.652-11.281-10.087-15.409c-.772-7.328,2.578-7.839,2.578-7.839a6.7,6.7,0,0,0,1.847,4.94,36.206,36.206,0,0,0,8.483,6.349Z",
    transform: "translate(-220.625 -220.96)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M246.8,248.909l-2.465-1.062,1.259-4.115Z",
    transform: "translate(-230.591 -231.508)",
    fill: "#f5d27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M251.053,247.847l-2.465,1.062,1.212-5.177Z",
    transform: "translate(-232.379 -231.508)",
    fill: "#f5d27a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M251.053,247.847l-2.465,1.062,1.212-5.177Z",
    transform: "translate(-188.307 -174.189)",
    fill: "#2d253f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M265.131,228.381a6.043,6.043,0,0,1-.274,1.243c-1.324,3.961-9.385,14.584-9.385,14.584l-3.54-6.91-1.254-4.115,1.973-.935a36.206,36.206,0,0,0,8.483-6.349,6.7,6.7,0,0,0,1.847-4.94S265.565,224.739,265.131,228.381Z",
    transform: "translate(-189.186 -163.641)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M246.395,248.909l-3.024-1,1.818-4.175Z",
    transform: "translate(-186.114 -174.189)",
    fill: "#2d253f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M249.778,208.643a.631.631,0,0,1,.358-.08.361.361,0,0,1,.251.451.955.955,0,0,1-.359.449,6.169,6.169,0,0,1-7.105.413c-.311-.188-.648-.522-.476-.827a2.542,2.542,0,0,1,1.679.112A7.868,7.868,0,0,0,249.778,208.643Z",
    transform: "translate(-185.706 -157.897)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M186.155,370.831v10.086h-32.9c-5.217,0-9.129-3.248-8.619-8.884A52.358,52.358,0,0,1,147.354,361a54.391,54.391,0,0,0,16.091,5.679c.423.086.864.166,1.31.242l.209.038Z",
    transform: "translate(-144.591 -228.509)",
    fill: "#e2a0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M323.909,377.24c-1.466,2.378-4.243,3.677-7.541,3.677h-32.9V370.831l21.192-3.87.209-.038c.446-.075,1.82-.655,2.243-.741A48.019,48.019,0,0,0,322.269,361a52.357,52.357,0,0,1,2.719,11.031A8.342,8.342,0,0,1,323.909,377.24Z",
    transform: "translate(-202.97 -228.509)",
    fill: "#fbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M323.909,391.252c-1.466,2.378-4.243,3.677-7.541,3.677h-32.9v-3.6C292.962,391.424,311.743,391.563,323.909,391.252Z",
    transform: "translate(-202.97 -242.52)",
    fill: "#e2a0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M243.371,251.458v23.778h5.489V251.4l-2.465,1.062Z",
    transform: "translate(-186.114 -177.74)",
    fill: "#2d253f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 1.377,
    cy: 1.275,
    rx: 1.377,
    ry: 1.275,
    transform: "translate(58.749 78.44)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 1.377,
    cy: 1.275,
    rx: 1.377,
    ry: 1.275,
    transform: "translate(58.749 88.639)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M208.532,186.492c-1.293.2-5.124-3.924-5.124-7.827s.655-5.862,1.849-6.227,3.275-.129,3.275,1.825c0,0,2.075,9.507,2.319,10.237S209.825,186.293,208.532,186.492Z",
    transform: "translate(-169.315 -141.1)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M282.977,184.856a2.48,2.48,0,0,1-.342-.043c-1.188-.209-2.324-1.063-2.168-1.745.174-.746,1.287-10.387,1.287-10.387-.2-1.943,1.849-2.357,3.072-2.1a1.405,1.405,0,0,1,.562.263c.927.666,1.577,2.523,1.9,5.776C287.684,180.508,284.287,184.947,282.977,184.856Z",
    transform: "translate(-201.702 -140.275)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M208.949,152.923c0-6.057-1.109-7.61-1.109-11.826s3.688-16.56,23.671-15.821,22.344,11.271,22.67,15.266-.816,11.928-.816,11.928",
    transform: "translate(-171.178 -119.306)",
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M208.949,155.106c0-5.495-1.109-6.945-1.109-10.77s3.688-15.021,23.671-14.35,22.344,10.224,22.67,13.847-.816,10.819-.816,10.819",
    transform: "translate(-171.178 -121.489)",
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M284.56,185.143a2.482,2.482,0,0,1-.342-.043,102.744,102.744,0,0,0,2.753-13.968c.927.666,1.577,2.523,1.9,5.776C289.267,180.794,285.87,185.234,284.56,185.143Z",
    transform: "translate(-203.285 -140.561)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M208.532,186.615c-1.293.2-5.124-3.924-5.124-7.827s.655-5.862,1.849-6.227C205.257,172.562,206.915,183.2,208.532,186.615Z",
    transform: "translate(-169.315 -141.223)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453",
    transform: "translate(64.7 40.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M275.449,189.247l-.007.042a30.658,30.658,0,0,1-3.2,8.807,21.643,21.643,0,0,1-4.8,6.028,16.2,16.2,0,0,1-7.783,3.682l.219,1.054a17.425,17.425,0,0,0,8.559-4.127,25.323,25.323,0,0,0,6.569-9.848,29.733,29.733,0,0,0,1.589-5.479l-1.147-.158Z",
    transform: "translate(-257.662 -189.247)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M259.4,224.623l-1.4.184a1.548,1.548,0,0,1-1.767-1.23,1.471,1.471,0,0,1,1.329-1.637l1.4-.184a1.547,1.547,0,0,1,1.767,1.23A1.47,1.47,0,0,1,259.4,224.623Z",
    transform: "translate(-256.213 -204.299)",
    fill: "#29283f"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 227.222,
    height: 48.08,
    transform: "translate(31.182 220.32)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2456",
    "data-name": "Group 2456",
    transform: "translate(153.248 153.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 13.19,
    height: 19.836,
    rx: 3.285,
    transform: "translate(0 3.326)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 2.141,
    height: 6.653,
    transform: "translate(5.524)",
    fill: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2457",
    "data-name": "Group 2457",
    transform: "translate(99.897 164.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M259.052,352.69H175.66l-3.3-41.73a4.368,4.368,0,0,1,4.544-4.528h80.913a4.368,4.368,0,0,1,4.544,4.528Z",
    transform: "translate(-172.344 -306.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    d: "M0,0H83.285a0,0,0,0,1,0,0V0a2.952,2.952,0,0,1-2.952,2.952H2.952A2.952,2.952,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(3.317 46.258)",
    fill: "#cfecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M5.237.138a5.452,5.452,0,0,1,5.375,5.1,4.783,4.783,0,0,1-5.1,4.822A5.452,5.452,0,0,1,.138,4.96,4.783,4.783,0,0,1,5.237.138Z",
    transform: "matrix(0.924, -0.383, 0.383, 0.924, 38.095, 20.475)",
    fill: "#f97e53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460",
    transform: "translate(51.51 166.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M110.408,349.557a49.812,49.812,0,0,0,2.724-25.823,35.806,35.806,0,0,0-8.187,25.157Z",
    transform: "translate(-95.579 -316.655)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M99.524,345.924a48.367,48.367,0,0,0-9.432-35.378,39.476,39.476,0,0,0,5.724,32.3Z",
    transform: "translate(-88.865 -310.546)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M109.551,358.764l-1.93,13.482-1.026,7.143H94.616l-2.329-16.278-.627-4.353h4.75Z",
    transform: "translate(-90.04 -332.878)",
    fill: "#f97e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M113,358.764l-1.93,13.482-11.21-13.488Z",
    transform: "translate(-93.486 -332.878)",
    fill: "#ffc5ab"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 238.098,
    height: 7.4,
    transform: "translate(25.744 213.702)",
    fill: "#29283f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461",
    transform: "translate(214.217 232.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M435.522,460.18a20.027,20.027,0,0,0-2.867-5.722c-.7-.986-1.669-1.862-2.28-2.886A5.147,5.147,0,0,0,428.853,450a10.652,10.652,0,0,0-6.4-2.381c-2.211.051-4.383,1.035-6.559.676-3.4-.562-5.138-3.952-7.379-6.383-4.409-5.1-11.6-5.355-17.946-4.218-2.113-.208-3.737-1.739-5.5-2.841-4.155-2.539-10.809-3.345-14.7-.04-4.062,6.131,8.521,8.731,9.8,13.9.492,1.934.274,3.409.625,5.368,1.467,6.023,9.432,11.382,15.7,10.645A20.051,20.051,0,0,0,400.536,474a18.842,18.842,0,0,0,10.475,6.147,30.639,30.639,0,0,0,6.567.733c.573.006,1.147,0,1.719-.022.531-.018,1.08.112,1.6.065,1.543-.142,3.217-1.349,4.488-2.092,3.226-1.887,6.545-3.883,8.6-6.862a13.577,13.577,0,0,0,1.816-10.764Q435.676,460.688,435.522,460.18Z",
    transform: "translate(-369.572 -432.627)",
    fill: "#191438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M383.988,442.835c22.2,6.694,57.278,38.411,57.278,38.411",
    transform: "translate(-375.632 -437.355)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    transform: "translate(236.302 198.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M480.443,427.619a25.59,25.59,0,0,0-.97-8.35c-.424-1.519-1.243-3.009-1.54-4.542a6.405,6.405,0,0,0-1.19-2.59,13.341,13.341,0,0,0-6.963-5.537c-2.81-.812-6-.432-8.58-1.749-4.023-2.055-4.651-7.019-6.351-10.971-3.2-8.181-12.146-11.348-20.673-12.432-2.568-1.1-3.907-3.674-5.617-5.761-4.066-4.848-12.08-8.5-18.514-5.879-7.954,6.118,6.706,14.384,5.926,21.4-.274,2.632-1.231,4.4-1.694,7.015-.934,8.174,6.629,18.088,14.87,19.643a25.831,25.831,0,0,0,.8,13.3,23.384,23.384,0,0,0,10.363,11.9,39.286,39.286,0,0,0,7.94,3.528c.719.235,1.446.451,2.177.654.678.188,1.311.571,1.986.716,2.01.434,4.678-.425,6.625-.858,4.94-1.1,10.045-2.3,14.01-5.242a18.888,18.888,0,0,0,7.265-12.849Q480.4,428.321,480.443,427.619Z",
    transform: "translate(-407.673 -368.933)",
    fill: "#ffa89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M425.561,383.885c24.889,17.239,54.451,71.129,54.451,71.129",
    transform: "translate(-415.192 -375.859)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463",
    transform: "translate(-11.593 205.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M-19.338,443.919a22.536,22.536,0,0,1-.584-7.387c.108-1.38.565-2.793.561-4.167a5.516,5.516,0,0,1,.59-2.42,11.313,11.313,0,0,1,5.1-5.824c2.3-1.116,5.135-1.253,7.146-2.773,3.139-2.372,2.838-6.771,3.638-10.449,1.38-7.567,8.6-11.624,15.815-13.813,2.04-1.33,2.763-3.76,3.89-5.821,2.7-4.8,9.03-9.145,15.06-7.811,7.946,4.144-3.364,13.462-1.489,19.436.687,2.244,1.819,3.642,2.667,5.839,2.206,6.956-2.664,16.664-9.549,19.22a22.853,22.853,0,0,1,1.573,11.66,19.862,19.862,0,0,1-6.96,11.843,33.466,33.466,0,0,1-6.287,4.224q-.876.463-1.777.886c-.556.263-1.04.687-1.6.912-1.671.67-4.132.316-5.894.225-4.474-.231-9.108-.526-13.051-2.5a17.282,17.282,0,0,1-8.5-10.085Q-19.183,444.523-19.338,443.919Z",
    transform: "translate(20 -383.21)",
    fill: "#e5aaa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M34.175,397.4c-18.652,18.6-35.1,69.686-35.1,69.686",
    transform: "translate(11.983 -389.785)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2469",
    "data-name": "Group 2469",
    transform: "translate(65.273 78.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2466",
    "data-name": "Group 2466",
    transform: "translate(122.959 1.059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 18.157,
    cy: 16.815,
    rx: 18.157,
    ry: 16.815,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M341.8,179.827c2.673-.258,7.076-1.952,11.068-5.649s5.822-7.774,6.1-10.25a4.357,4.357,0,0,0-1.7-3.575.916.916,0,0,0-1.329.124l-3.795,5.2a.771.771,0,0,0,.27,1.139l.791.443a1.472,1.472,0,0,1,.526,1.913c-.434,1.214-4.956,5.4-6.268,5.8a1.744,1.744,0,0,1-2.066-.487l-.478-.732a.91.91,0,0,0-1.23-.25l-5.612,3.514a.771.771,0,0,0-.134,1.23A5.018,5.018,0,0,0,341.8,179.827Z",
    transform: "translate(-330.188 -153.585)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2468",
    "data-name": "Group 2468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2467",
    "data-name": "Group 2467"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 19.3,
    cy: 17.874,
    rx: 19.3,
    ry: 17.874,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M142.877,154.156l.873-1.264-1.345-.172-5.528-.708,3.74,5.416,1.323-1.916a12.89,12.89,0,0,1,6.59,11.069,12.583,12.583,0,0,1-4.14,9.256,14.946,14.946,0,0,1-19.99,0,12.418,12.418,0,0,1,0-18.513,14.674,14.674,0,0,1,10-3.834v-1.61c-8.768,0-15.873,6.581-15.874,14.7s7.106,14.7,15.874,14.7,15.873-6.581,15.874-14.7A14.478,14.478,0,0,0,142.877,154.156Z",
    transform: "translate(-115.095 -148.709)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_24",
    "data-name": 24,
    transform: "translate(11.502 20.857)",
    fill: "#ff725e",
    fontSize: 13,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476",
    transform: "translate(85.924 31.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 18.157,
    cy: 16.815,
    rx: 18.157,
    ry: 16.815,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M182.945,82.489c0-5.059-5.511-9.159-12.308-9.159s-12.308,4.1-12.308,9.159,5.51,9.159,12.308,9.159a16.321,16.321,0,0,0,3.139-.312l4.362,2.418-.813-3.583C180.705,88.538,182.945,85.711,182.945,82.489Z",
    transform: "translate(-152.48 -65.674)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471",
    transform: "translate(9.979 15.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M168.771,89.067a1.664,1.664,0,1,1-1.659-1.536A1.6,1.6,0,0,1,168.771,89.067Z",
    transform: "translate(-165.454 -87.531)",
    fill: "#ffcca9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M180.018,89.067a1.663,1.663,0,1,1-1.658-1.536A1.6,1.6,0,0,1,180.018,89.067Z",
    transform: "translate(-170.182 -87.531)",
    fill: "#ffcca9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M191.266,89.067a1.664,1.664,0,1,1-1.659-1.536A1.6,1.6,0,0,1,191.266,89.067Z",
    transform: "translate(-174.91 -87.531)",
    fill: "#ffcca9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475",
    transform: "translate(81.656 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 18.157,
    cy: 16.815,
    rx: 18.157,
    ry: 16.815,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474",
    transform: "translate(7.697 9.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M314.02,83.825l-9.889-6.393H323.9Z",
    transform: "translate(-303.123 -77.432)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M324.18,78.657V92.088H302.392V78.652l10.9,7.043Z",
    transform: "translate(-302.392 -77.997)",
    fill: "#ff725e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9bb0825a95cd4696fca3e28ae1074241.svg";
export { ForwardRef as ReactComponent };